import React from "react";
import { StyleSheet } from "react-native";
import Text from "@components/CustomText";
import BottomSheet from "@components/ds/BottomSheet";
import SheetButtons from "@components/ds/SheetButtons";
import { tokens } from "../styles";

// Confirm sheet for /unpack-visible — mirrors web's confirmUnpack().

const UnpackConfirmSheet = ({
  visible,
  crate,
  onClose,
  onConfirm,
  unpacking,
}) => {
  const items = Array.isArray(crate?.items) ? crate.items : [];
  const count = items.filter((it) => Boolean(it?.packed_at)).length;
  return (
    <BottomSheet
      visible={visible}
      title="Confirm Unpack"
      onClose={onClose}
      footer={
        <SheetButtons
          onCancel={onClose}
          onConfirm={onConfirm}
          loading={unpacking}
          destructive
          confirmLabel="Unpack"
        />
      }
    >
      <Text variant="caption_2" style={styles.body}>
        Unpack{" "}
        <Text variant="caption_2" style={styles.strong}>
          {count}
        </Text>{" "}
        items from{" "}
        <Text variant="caption_2" style={styles.strong}>
          {crate?.title || "this crate"}
        </Text>
        ?
      </Text>
      <Text variant="caption_2" style={styles.warning}>
        This will remove the packing status from the selected items.
      </Text>
    </BottomSheet>
  );
};

export default UnpackConfirmSheet;

const styles = StyleSheet.create({
  body: { color: tokens.textPrimary, fontSize: 13 },
  strong: { color: tokens.textPrimary, fontWeight: "700" },
  warning: { color: tokens.textSecondary, fontSize: 12, marginTop: 8 },
});
